module.exports = __webpack_public_path__ + "img/motor_no13.c29509f0.jpg";